import {
  Button,
  Card,
  Divider,
  InlineGrid,
  Link,
  Select,
  Text,
} from "@shopify/polaris";
import {
  contentLanguageOptions,
  primaryTargetCountryOption,
} from "../../utils/constants";
import { useCallback, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { usePlan } from "../../context/PlanContext";

const SubmitFeed = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const urlParams = new URLSearchParams(location.search);
  const paramValue = urlParams.get("shop");
  const { hasFeature } = usePlan();
  const [selectedTargetMarket, setSelectedTargetMarket] = useState("today");
  const [selectedContentLanguage, setSelectedContentLanguage] =
    useState("today");

  const handleContentLanguageChange = useCallback(
    (value) => setSelectedContentLanguage(value),
    []
  );

  const handleTargetMarketChange = useCallback(
    (value) => setSelectedTargetMarket(value),
    []
  );
  return (
    <Card>
      <div style={{ display: "flex", columnGap: "5px", alignItems: "end" }}>
        <Text variant="headingMd" as="h6">
          Submit Feed to Additional Countries (For Google Only)
        </Text>
        {/* <Text variant="bodySm" fontWeight="regular" as="p">
          <Link url="https://help.shopify.com/manual">
            Help Video - Must Watch
          </Link>
        </Text> */}
      </div>

      <div
        style={{
          display: "flex",
          flexDirection: "column",
          rowGap: "15px",
          marginTop: "15px",
        }}
      >
        <Text variant="bodyMd" as="p">
          This feature allows you to submit feeds for additionaL target
          countries using your default currency. The content language will be
          the same as your primary target market. You can then create dedicated
          campaigns for each country in your Google Ads account.
        </Text>

        {/* <Text variant="bodyMd" fontWeight="semibold" as="p">
          You have chosen to submit your products feed to following countries{" "}
          <span style={{ background: "#ad117c45", color: "#f114ac" }}>
            Belgium
          </span>{" "}
          along with your default country{" "}
          <span style={{ background: "#ad117c45", color: "#f114ac" }}>
            Netherlands
          </span>
        </Text> */}
      </div>

      <div
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          marginTop: "10px",
        }}
      >
        <Button
          variant="primary"
          disabled={!hasFeature("multi_country")}
          onClick={() => {
            navigate(`/manage_additional_countries?shop=${paramValue}`);
          }}
        >
          Manage Additional Countries
        </Button>
      </div>
      {!hasFeature("multi_country") ? (
        <Text variant="bodySm" as="p" tone="subdued">
          Upgrade to Pro or Unlimited to manage additional countries.
        </Text>
      ) : null}
    </Card>
  );
};

export default SubmitFeed;
